// src/OrganizationForm.js
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import apiClient from '../../global/utils/apiClient'
import { useMetaStore } from '../../scoring/store/MetaStore'
import { useAdminStore } from '../store/AdminStore'
import OrganizationView from '../views/OrganizationView'

function OrganizationController() {
  const setOrgId = useAdminStore((state) => state.setOrgId)
  const [searchParams] = useSearchParams()
  const orgId = searchParams.get('orgId')
  const [organizationData, setOrganizationData] = useState({
    orgName: '',
  })
  const setGlobalModal = useMetaStore((state) => state.setGlobalModal)
  const navigate = useNavigate()

  useEffect(() => {
    // Fetch org data from the API when the component mounts
    if (orgId) {
      setOrgId(orgId)
      apiClient.get(`/gskapi/org/find/${orgId}`)
        .then((response) => {
          setOrganizationData(response.data)
        })
        .catch((error) => {
          console.error('Error fetching org data:', error)
        })
    }
  }, [orgId])

  const handleChange = (e) => {
    const { name, value } = e.target
    setOrganizationData({ ...organizationData, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const response = await apiClient.post('/gskapi/org/save', organizationData)

      if (response.status === 200 || response.status === 201) {
        console.log('Organization data saved successfully!')
        setGlobalModal(true, 'Save Successful', '#060')
        navigate('/admin/orgs')
      } else {
        console.error('Failed to save organization data.')
        setGlobalModal(true, 'Failed to save organization data.', '#900')
      }
    } catch (error) {
      console.error('Error saving organization data:', error)
      setGlobalModal(true, 'Error saving organization data.', '#900')
    }
  }

  return (
    <OrganizationView
      organizationData={organizationData}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
    />
  )
}

export default OrganizationController
